import { Injectable } from '@angular/core';
import { LocationChangeEvent, LocationStrategy } from '@angular/common';
import { Filter } from '../models/filter.model';
import { FilterService } from './filter.service';
import { StateHelper } from '../helpers/state.helper';
import { UrlHelper } from '../helpers/url.helper';
import { deepEqual } from 'fast-equals';

@Injectable()
export class FilterUrlService {
  constructor(
    private filterService: FilterService,
    private locationStrategy: LocationStrategy,
    private stateHelper: StateHelper,
    private urlHelper: UrlHelper,
  ) {
    this.locationStrategy.onPopState((event: LocationChangeEvent) => {
      if (event.type === 'popstate') {
        if (event.state) {
          const filters: Filter[] =
            this.stateHelper.createFiltersFromStateObject(event.state);
          this.filterService.updateFilter(filters);
        } else {
          this.filterService.initializeCurrentFilter(true);
        }
      }
    });

    this.filterService.currentFilter$.subscribe((filters: Filter[]) => {
      if (filters.length) {
        this.updateUrl(filters);
      }
    });
  }

  /**
   * Transfer formgroup data to a shareable URL
   * @param filters: the filter to update in the url
   */
  private updateUrl(filters: Filter[]): void {
    const queryParams = this.urlHelper.filterToUrl(filters);

    const filtersForState: Filter[] = JSON.parse(
      JSON.stringify(this.stateHelper.createFiltersForState(filters)),
    );
    const currentState = history.state;
    if (!currentState) {
      this.locationStrategy.replaceState(
        filtersForState,
        document.title,
        '',
        queryParams,
      );
    } else {
      if (!deepEqual(filtersForState, currentState)) {
        this.locationStrategy.pushState(
          filtersForState,
          document.title,
          '',
          queryParams,
        );
      }
    }
  }
}
